import { render, staticRenderFns } from "./Agent.vue?vue&type=template&id=ac5f484a&scoped=true"
import script from "./Agent.vue?vue&type=script&lang=js"
export * from "./Agent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5f484a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac5f484a')) {
      api.createRecord('ac5f484a', component.options)
    } else {
      api.reload('ac5f484a', component.options)
    }
    module.hot.accept("./Agent.vue?vue&type=template&id=ac5f484a&scoped=true", function () {
      api.rerender('ac5f484a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Agent/Agent.vue"
export default component.exports